class BrandsCarousel {
  constructor(container) {
    this.container = container;
    this.cardsContainer = container.querySelector('.brands-carousel__cards');
    this.scrollSpeed = parseInt(container.dataset.scrollSpeed) || 30;
    this.textDirection = container.dataset.textDirection || 'ltr';
    this.spacing = parseInt(container.dataset.spacing) || 20;
  }

  init() {
    if (!this.cardsContainer) return;

    if (this.container.dataset.initialized === 'true') {
      return;
    }

    // Check if user prefers reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.duplicateCards();
    this.setAnimationSpeed();
    this.setupHoverPause();

    this.cardsContainer.classList.add('animate');
    this.container.dataset.initialized = 'true';
    this.initialized = true;
  }

  duplicateCards() {
    // Clone all cards to create seamless loop
    const cards = Array.from(this.cardsContainer.children);

    cards.forEach((card, i) => {
      card.dataset.id = 'original-' + i;
      const clone = card.cloneNode(true);
      clone.dataset.id = 'clone-' + i;
      this.cardsContainer.appendChild(clone);
    });
  }

  setAnimationSpeed() {
    const firstCard = this.cardsContainer.firstElementChild;
    if (!firstCard) return;

    const cardWidth = firstCard.offsetWidth;
    const cardCount = this.cardsContainer.children.length / 2; // Half because we duplicated
    const totalWidth = (cardWidth + this.spacing) * cardCount;

    // Adjust animation duration based on scroll speed and content width
    const duration = this.scrollSpeed * (totalWidth / 1200); // Normalize based on width

    this.cardsContainer.style.animationDuration = `${duration}s`;
  }

  setupHoverPause() {
    // Pause animation on hover for better UX
    this.container.addEventListener('mouseenter', () => {
      this.cardsContainer.style.animationPlayState = 'paused';
    });

    this.container.addEventListener('mouseleave', () => {
      this.cardsContainer.style.animationPlayState = 'running';
    });
  }
}

// Initialize all brand carousels when DOM is loaded
if (document.readyState !== 'loading') {
  initializeAllCarousels();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    initializeAllCarousels();
  });
}

function initializeAllCarousels() {
  document.querySelectorAll('.brands-carousel').forEach((carousel) => {
    const instance = new BrandsCarousel(carousel);
    instance.init();
  });
}

// Re-initialize on page transitions (for SPA behavior)
document.addEventListener('shopify:section:load', (event) => {
  initializeAllCarousels();
});
